import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ShoppingBag,
  HeartPulse,
  GraduationCap,
  Landmark,
  Home,
  Plane,
  Truck,
  Store,
  Radio,
  Cloud,
  type LucideIcon,
} from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

type Industry = {
  name: string;
  icon: LucideIcon;
};

const industries: Industry[] = [
  { name: "Ecommerce", icon: ShoppingBag },
  { name: "Healthcare", icon: HeartPulse },
  { name: "Education", icon: GraduationCap },
  { name: "Banking", icon: Landmark },
  { name: "Real Estate", icon: Home },
  { name: "Travel", icon: Plane },
  { name: "Logistics", icon: Truck },
  { name: "Retail", icon: Store },
  { name: "Telecom", icon: Radio },
  { name: "SaaS", icon: Cloud },
];

const ChatBotUseCases: React.FC = () => (
  <AnimatedSection as="section" className="cbot-section" aria-labelledby="cbot-usecases-title">
    <div className="cbot-container">
      <SectionHeader
        eyebrow="Chatbot Use Cases"
        title="Industries We Serve"
        text="AI chatbots transforming customer engagement across every major industry vertical."
      />

      <div className="cbot-industry-grid">
        {industries.map((industry, index) => {
          const Icon = industry.icon;
          return (
            <motion.article
              key={industry.name}
              className="cbot-industry-card"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.04 }}
              whileHover={{ y: -6, scale: 1.02 }}
            >
              <div className="cbot-industry-card__illus" aria-hidden="true">
                <Icon size={28} />
              </div>
              <h3>{industry.name}</h3>
            </motion.article>
          );
        })}
      </div>

      <div className="cbot-section-cta">
        <Link className="cbot-btn cbot-btn--ghost" to="/contact">
          Explore All Industries
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      </div>
    </div>
  </AnimatedSection>
);

export default ChatBotUseCases;
